export default __webpack_public_path__ + "static/media/popup_03.56d4be8b.mp3";